import { FilterRequestType } from '..';

export class FilterRequestModel<T> {
    constructor(
        public value?: T,
        public operation?: FilterRequestType
    ) { }
}
